import keymirror from 'keymirror';

export default keymirror({
  GET_WEBINARS: null,
  GET_WEBINARS_SUCCESS: null,
  GET_WEBINARS_NEXT_PAGE_SUCCESS: null,
  GET_WEBINARS_ERROR: null,
});